import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { Observable, Subject, of } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { Api, Webhook } from '../../../../_models';
import { CustomerService } from '../../../../_services';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { icons } from '../../../../sharedcomp/constans/icons.constans';
import { DataService } from 'src/app/_helpers';

@Component({
  selector: 'app-webhook',
  templateUrl: './webhook.component.html',
  styleUrls: [
    './webhook.component.css',
    '../../../../../assets/css/new-component-view.css',
    '../../../../../assets/css/new-buttons-theme.css',
    '../../../../../assets/css/new-form-elements.css'
  ]
})
export class WebhookSubComponent implements OnInit, OnDestroy {

  icons: typeof icons;

  @Input() customerPublicId: string;
  isWebhookFormChange: boolean;
  isUpdateBtnEnable: boolean = true;
  webhookForm: FormControl = new FormControl('', [Validators.required]);
  webhook$: Observable<Webhook>;

  initialFormValue: string;
  updateSucess: boolean = false;
  updateError: boolean = false;

  isWebhookValidated: boolean = false;
  isValidating: boolean = false;
  validateError: string = '';

  private destroy$ = new Subject<void>();

  constructor(
    private customerService: CustomerService,
    private router: Router,
    private dataService: DataService
  ) {
    this.icons = icons;
   }

  ngOnInit() {
    this.dataService.loadSpinner(true);
    this.setWebhookObservable();
  }

  canSave() {
    this.isWebhookFormChange = this.initialFormValue !== this.webhookForm.value;
    this.updateSucess = false;
    this.updateError = false;
    // CA-04: al editar la URL se resetea el estado de validacion y Guardar vuelve a deshabilitarse
    this.isWebhookValidated = false;
    this.validateError = '';
  }

  validateWebhook() {
    if (!this.webhookForm.valid || this.isValidating) { return; }

    this.isValidating = true;
    this.validateError = '';
    this.isWebhookValidated = false;
    this.dataService.loadSpinner(true);

    this.customerService.testWebhook(this.customerPublicId, { value: this.webhookForm.value })
      .pipe(
        takeUntil(this.destroy$),
        tap((res: any) => {
          this.isValidating = false;
          this.dataService.loadSpinner(false);
          if (res && res.valid) {
            this.isWebhookValidated = true;
            this.validateError = '';
          } else {
            this.isWebhookValidated = false;
            this.validateError = 'Debe especificar un webhook válido.';
          }
        }),
        catchError(err => {
          this.isValidating = false;
          this.dataService.loadSpinner(false);
          this.isWebhookValidated = false;
          this.validateError = 'Debe especificar un webhook válido.';
          console.error('Failed while trying to validate webhook.', err);
          return of(null);
        })
      )
      .subscribe();
  }

  goBack() {
    this.router.navigateByUrl('/dashboard');
  }

  setWebhookObservable() {
    this.webhook$ = this.customerService.getWebhook(this.customerPublicId)
      .pipe(
        takeUntil(this.destroy$),
        tap(data => {
          this.webhookForm.setValue(data.value);
          this.initialFormValue = data.value;
          this.webhookForm.valueChanges
          .pipe(takeUntil(this.destroy$))
          .subscribe(() => this.canSave());
          this.dataService.loadSpinner(false);
        }),
        catchError(err => {
          console.error('Failed while trying to get webhook. ' + err);
          this.dataService.loadSpinner(false);
          return of({ value: '' })
        })
      )
  }

  updateWebhook(newWebhook: FormControl) {
    this.dataService.loadSpinner(true);
    this.isUpdateBtnEnable = false;

    const webhookPayload = {
      value: newWebhook.value
    };

    this.customerService.createWebhook(this.customerPublicId, webhookPayload)
      .pipe(tap(data => {
        this.initialFormValue = data.value;
        this.isWebhookFormChange = false;
        this.isWebhookValidated = false;

        this.updateSucess = true;
        this.updateError = false;
        this.isUpdateBtnEnable = true;
        this.dataService.loadSpinner(false);
      }),
        catchError(error => {
          this.updateSucess = false;
          this.updateError = true;
          this.isUpdateBtnEnable = true;
          this.dataService.loadSpinner(false);
          console.error('Failed! while trying to update webhook.', error);
          return of(null)
        })
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
